import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { cpfFormat, dateFormat } from '@shared/formatters';
import { CondutorController } from '@modules/condutores/controllers';
import { CondutorModel, GetCondutorModel } from '@data/condutor/models';
import { AuthService } from '@infra/auth/auth.service';
import { BaseListagemComponent } from '@common/modules/base/base-listagem.component';
import { FormularioCondutorComponent } from '@modules/condutores/components/formulario-condutor/formulario-condutor.component';
import { Coluna } from '@components/table/table.component';
import { Acao } from '@components/filtros/filtros.component';
import { Campo } from '@components/form/form.component';
import { modal } from '@shared/alerts/modal/modal.alert';

@Component({
  selector: 'app-condutores',
  templateUrl: './condutores.component.html',
  styleUrls: ['./condutores.component.scss'],
})
export class CondutoresComponent extends BaseListagemComponent<GetCondutorModel> {
  protected filtros: Campo[] = [
    {
      name: 'pessoa.razaoSocial%',
      label: 'Nome Condutor',
      type: 'text',
      icon: 'person',
      width: 'calc(100% / 3)',
      mask: '',
      validators: [],
    },
    {
      name: '%pessoa.cpf%',
      label: 'CPF Condutor',
      type: 'text',
      icon: 'subtitles',
      width: 'calc(100% / 3)',
      mask: '000.000.000-00',
      validators: [],
    },
    {
      name: 'pessoa.rg',
      label: 'RG Condutor',
      type: 'text',
      icon: 'subtitles',
      width: 'calc(100% / 3)',
      mask: '',
      validators: [],
    },
  ];

  protected acoes: Acao[] = [
    {
      icon: 'add',
      tooltip: 'Inserir Condutor',
      action: this.inserirCondutor.bind(this),
      disabled: !this.authService.hasPermission('condutor', 'INSERIR'),
    },
  ];

  protected colunas: Coluna[] = [
    { name: 'nomeCondutor', label: 'Nome Condutor' },
    { name: 'cpf', label: 'CPF', format: cpfFormat },
    { name: 'rg', label: 'RG' },
    { name: 'habilitacao', label: 'Nº da CNH' },
    { name: 'numeroSegurancaCNH', label: 'Nº Registro CNH' },
    { name: 'orgaoEmissorHabilitacao', label: 'Órgão Emissor CNH' },
    { name: 'categoria', label: 'Categoria CNH' },
    { name: 'validade', label: 'Data Validade CNH', format: dateFormat },
    {
      name: 'acoes',
      label: 'Ações',
      acoes: [
        {
          label: 'Editar Condutor',
          icon: 'edit',
          action: this.editarCondutor.bind(this),
          disabled: !this.authService.hasPermission('condutor', 'EDITAR'),
        },
        {
          label: 'Excluir Condutor',
          icon: 'delete',
          action: this.excluirCondutor.bind(this),
          disabled: !this.authService.hasPermission('condutor', 'DELETAR'),
        },
      ],
    },
  ];

  constructor(public condutorController: CondutorController, private authService: AuthService, private dialog: MatDialog) {
    super('Condutores - Portal do Cliente', condutorController);

    /**
     * Rotina de inserção de condutor iniciado por outro módulo
     */
    window.addEventListener('message', (event) => {
      if (event.data.message === 'INSERIR_CONDUTOR') {
        this.inserirCondutor((condutor: CondutorModel) => {

          if(event.source) {
            event.source.postMessage({ message: 'CONDUTOR_INSERIDO', data: JSON.stringify(condutor) });
            window.close();
          }
        });
      }
    });
  }

  protected inserirCondutor(callback?: (condutor: CondutorModel) => void) {
    const ref = this.dialog.open(FormularioCondutorComponent, {
      width: '850px',
      height: 'auto',
      disableClose: true,
    });

    ref.afterClosed().subscribe((result: CondutorModel) => {
      if (result) {
        this.filtrar();

        modal.fire({
          title: 'Sucesso!',
          text: 'Condutor inserido com sucesso!',
          icon: 'success',
          confirmButtonText: 'Continuar',
        });

        if (callback) {
          callback(result);
        }
      }
    });
  }

  private editarCondutor(condutor: GetCondutorModel) {
    const ref = this.dialog.open(FormularioCondutorComponent, {
      width: '850px',
      height: 'auto',
      data: { id: condutor.codigoCondutor },
    });

    ref.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.filtrar();

        modal.fire({
          title: 'Sucesso!',
          text: 'Condutor atualizado com sucesso!',
          icon: 'success',
          confirmButtonText: 'Continuar',
        });
      }
    });
  }

  private excluirCondutor(condutor: any) {
    modal.fire({
      title: 'Atenção!',
      text: 'Deseja realmente excluir este condutor?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.condutorController.delete(condutor.codigoCondutor).subscribe( {
          next: () => {
            this.filtrar();
  
            modal.fire({
              title: 'Sucesso!',
              text: 'Condutor excluído com sucesso!',
              icon: 'success',
              confirmButtonText: 'Continuar',
            });
          },
          error: (error) => {
            modal.fire({
              icon: error.icon,
              title: error.title,
              html: error.message,
            });
          },
        });
      }
    });
  }
}
